
import Slide from './carousel-slide'

export default {
  name: 'VsCarouselSlides',
  inheritAttrs: false,
  inject: ['carousel'],
  components: {
    Slide
  },
  props: {
    gap: {
      type: [String, Object],
      default: 'sm'
    },
    width: {
      type: [Number, String, Object],
      default: 'full'
    },
    height: {
      type: [Number, String, Object],
      default: null
    },
    slide: {
      type: Object,
      default: null
    }
  },
  vessel: {
    wrapper: {
      $width: 'width',
      $height: 'height',
      overflow: 'hidden'
    },
    container: {
      $height: 'height',
      $gap: {
        negativeMarginLeft(val) {
          return this.vertical ? null : val
        },
        negativeMarginTop(val) {
          return this.vertical ? val : null
        }
      }
    },
    item: {
      position: 'relative',
      overflow: 'hidden',
      $gap: {
        paddingLeft(val) {
          return this.vertical ? null : val
        },
        paddingTop(val) {
          return this.vertical ? val : null
        }
      }
    }
  },
  computed: {
    items() {
      return this.carousel.items || []
    },
    vertical() {
      return this.carousel.vertical
    },
    direction() {
      return this.carousel.vertical ? 'col' : 'row'
    },
    size() {
      const size = this.carousel.itemsPerView
      const prop = this.vertical ? 'height' : 'width'

      return Object(size && { [prop]: `${100 / size}%` })
    }
  },
  methods: {
    isActive(index) {
      return this.carousel.isItemActive(index)
    },
    isInView(index) {
      return this.carousel.itemInView(index)
    },
    clickAllowed() {
      return this.carousel.call('clickAllowed')
    },
    onClick(index, item) {
      if (this.clickAllowed()) {
        this.$emit('click', index, item)
      }
    },
    sync({ trackActive, trackInView }) {
      if (trackActive || trackInView) {
        this.$refs.slides.forEach((slide, index) => {
          slide.active = this.isActive(index)
          slide.inView = this.isInView(index)
        })
      }
    }
  },
  created() {
    this.carousel.$on('init', this.sync)
    this.carousel.$on('select', this.sync)
  },
  mounted() {
    this.$nextTick(() => {
      this.carousel.create(this.$el)
    })
  },
  beforeDestroy() {
    this.carousel.$off('init', this.sync)
    this.carousel.$off('select', this.sync)
  }
}
